<template>
  <div class="vote-container">
    <div class="content">
      <div v-for="item in voteList" :key="item.id" class="item">
        <div class="img-wrapper" @click="openDetail(item)"><img :src="item.avatar"></div>
        <span class="name">{{ item.name }}</span>
        <span class="title">{{ item.title }}</span>
        <div class="vote" @click="vote(item.id)">
          <img src="@/assets/zan_m.png">
          <span>{{ numbers[item.id] || item.numbers || 0 }}</span>
        </div>
      </div>
    </div>
    <el-dialog
        :lock-scroll="false"
        :modal="false"
        :visible.sync="showDetail"
        custom-class="vote-detail-dialog"
        top="20vw"
        width="68vw">
      <img :src="currentForShow.avatar"/>
      <span class="name">{{ currentForShow.name }}</span>
      <span class="title">{{ currentForShow.title }}</span>
      <span class="introduction">{{ currentForShow.introduction }}</span>
    </el-dialog>
    <div class="gzh">
      <img src="@/assets/gzh.jpg">
      <span>长按扫码</span>
      <span>关注更多精彩内容</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'VoteMobile',
  data() {
    return {
      voteList: [],
      numbers: {},
      showDetail: false,
      currentForShow: {}
    }
  },
  props: {},
  computed: {},
  methods: {
    refreshNumber() {
      this.$request.get('/server/vote/number').then(res => {
        if (res.code === 200) {
          this.numbers = res.data
        }
      })
    },
    vote() {
      // this.$request.post(`/server/vote/${id}`, {}).then(res => {
      //   if (res.code === 200) {
      //     this.refreshNumber()
      //   } else {
      //     this.$message(res && res.data)
      //   }
      // })
      this.$alert('投票已结束，感谢关注');
    },
    openDetail(item) {
      this.currentForShow = item;
      this.showDetail = true;
    }
  },
  watch: {},
  created() {
    this.$request.get('/server/vote/list').then(res => {
      if (res.code === 200) {
        this.voteList = res.data;
      }
    })
    this.refreshNumber()

    setTimeout(this.refreshNumber, 10000)
  },
  mounted() {
  }
}
</script>

<style lang="less">
html, body {
  height: 100%;
  min-height: 100%;
}

.vote-container {
  min-height: 100%;
  background-image: url("../../assets/vote_bg_m.jpg");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-color: #081f89;
  display: flex;
  flex-direction: column;

  .content {
    display: flex;
    flex-wrap: wrap;
    margin-left: 5vw;
    margin-top: 118vw;
    margin-bottom: 30vw;

    .item:nth-child(3n) {
      margin-right: 0;
    }

    .item {
      width: 28vw;
      margin-right: 3vw;
      display: flex;
      flex-direction: column;
      align-items: center;

      .img-wrapper {
        width: 100%;

        img {
          width: 100%;
        }
      }

      .name, .title {
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        font-size: 1rem;
        max-width: 100%;
        white-space: nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
        color: white;
      }

      .title {
        font-size: 0.75rem;
      }

      .vote {
        margin-top: 0.5rem;
        margin-bottom: 1.2rem;
        display: flex;
        align-items: center;
        color: #ffd026;

        img {
          width: 1rem;
          margin-right: 2px;
        }
      }
    }
  }

  .gzh {
    position: fixed;
    z-index: 1;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(8, 31, 138, 0.8);
    display: flex;
    flex-direction: column;
    align-items: center;
    color: white;
    line-height: 1.25rem;
    font-size: 0.875rem;
    padding-bottom: 0.5rem;

    img {
      width: 16.6vw;
      height: 16.6vw;
      margin-top: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }
}

.el-dialog.vote-detail-dialog {
  background-repeat: no-repeat;
  background-color: white;
  background-size: 100% auto;
  overflow-y: hidden;

  /deep/ .el-dialog__header {
    margin: 0;
    padding: 0;
    height: 5vw;
  }

  /deep/ .el-dialog__headerbtn {
    top: 1vw;
    right: 1vw;
    color: black;
    font-size: 2rem;
  }

  /deep/ .el-dialog__body {
    margin: 0;
    padding: 0 1rem;
    height: 118vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: black;

    img {
      width: 28vw;
    }

    .name {
      margin-top: 0.75rem;
      font-weight: bold;
    }

    .title {
      font-weight: bold;
      margin-top: 0.25rem;
    }

    .introduction {
      margin-top: 1rem;
      max-height: 52vw;
      overflow-y: auto;
      font-size: 0.75rem;
    }
  }
}
</style>
